import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface GiftCardEligibilityState {
  eligible: boolean
}

export const giftcardEligibilityInitialState: GiftCardEligibilityState = {
  eligible: false,
}

const giftcardEligibilitySlice = createSlice({
  name: 'giftcardEligibility',
  initialState: giftcardEligibilityInitialState,
  reducers: {
    setGiftCardEligibility(state: GiftCardEligibilityState, action: PayloadAction<boolean>) {
      state.eligible = action.payload
    },
  },
})

export const { setGiftCardEligibility } = giftcardEligibilitySlice.actions

export default giftcardEligibilitySlice.reducer
